import { Job } from "@core/domains/jobs";
import { adminApi, apiEndpoint } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

export const maintenanceApi = adminApi(
  { domain: API_DOMAIN, path: "maintenance" },
  {
    backfillMediaPreviews: apiEndpoint({
      response: z.object(
        { job: Job.schema },
        { job: "The backfill job started for the missing media previews" },
      ),
    }),
  },
);
